import { render, staticRenderFns } from "./customerCaseDetail.vue?vue&type=template&id=2ffe150e&scoped=true"
import script from "./customerCaseDetail.vue?vue&type=script&lang=js"
export * from "./customerCaseDetail.vue?vue&type=script&lang=js"
import style0 from "./customerCaseDetail.vue?vue&type=style&index=0&id=2ffe150e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffe150e",
  null
  
)

export default component.exports